export default ngModule => {

    ngModule.controller('ZohoCtrl', function (AonApi, AonApplicationService, OperatorService, $state, $stateParams, ZohoService) {

        this.status = 'Retrieving your details...';

        const fetchPriceInfo = (applicant, priceId) => {
            this.status = 'Retrieving product information...';

            return AonApi.fetchPrice(applicant, priceId).then(response => {
                const pkg = response.data;
                const price = pkg.price;
                pkg.selectedPrice = price;
                AonApplicationService.setProduct(pkg);
                AonApplicationService.setPrice(price);
                _.set(applicant, 'policy.membership_type', price.membership_type);
                _.set(applicant, 'primary_address.state', price.state);
                AonApplicationService.saveApplication(applicant);
                const fund_code = price.fund.code.split('.')[0];
                $state.go(`comparator.step3.${fund_code}`);
            });
        };

        const onZohoApplicant = zohoApp => {
            OperatorService.updateApplicantDependantFilters();
            if ($stateParams.price) {
                return AonApplicationService.getApplication().then((applicant) => {
                    return fetchPriceInfo(applicant, $stateParams.price);
                });
            } else {
                $state.go('operator.step1');
            }
        };

        ZohoService.getZohoApplicant($stateParams.leadId, $stateParams.operator)
            .then(onZohoApplicant)
            .catch(() => $state.go('operator.step1'));
    });
};


// WEBPACK FOOTER //
// ./src/controllers/comparator/zoho-ctrl.js